<template>
    <div class='divider'></div>
</template>

<script>
  export default {
    name: "Divider"
  }
</script>

<style scoped>
    .divider {
        padding-top:10px;
        margin-bottom: 10px;
        border-bottom: 1px solid rgba(216, 216, 216, 1);
        width: 100%;
    }
</style>
